<app-inline-params>
  @if (car) {
    @if (car.model.firstRegistrationDate) {
      <app-inline-params-item [label]="'carDetail.specification.firstRegistrationDate' | translate">
        {{ car.model.firstRegistrationDate | date: 'yyyy' }}
      </app-inline-params-item>
    }
    @if (car.mileage && car.mileageUnit) {
      <app-inline-params-item [label]="'carDetail.specification.odometer' | translate"> {{ car.mileage | thousands }} {{ car.mileageUnit | lowercase }} </app-inline-params-item>
    }
    @if (car.engine?.engineSize) {
      <app-inline-params-item [label]="'carDetail.specification.volume' | translate"> {{ car.engine?.engineSize }} ccm </app-inline-params-item>
    }
    @if (car.engine?.performanceKW) {
      <app-inline-params-item [label]="'carDetail.specification.performance' | translate"> {{ car.engine?.performanceKW }} kW </app-inline-params-item>
    }
    @if (car.fuel?.title) {
      <app-inline-params-item [label]="'carDetail.specification.fuel' | translate">
        {{ car.fuel?.title }}
      </app-inline-params-item>
    }
    @if (car.engine?.is4x4) {
      <app-inline-params-item [label]="'carDetail.specification.drive' | translate"> 4x4 </app-inline-params-item>
    }
    @if (car.body?.title) {
      <app-inline-params-item [label]="'carDetail.specification.bodyType' | translate">
        {{ car.body?.title }}
      </app-inline-params-item>
    }
    @if (car.gearbox) {
      <app-inline-params-item [label]="'carDetail.specification.gearbox' | translate">
        @if (car.gearbox.id === 'A') {
          {{ car.gearbox.title }} / {{ car.gearbox.steps }} {{ 'carDetail.specification.gearboxSpeed' | translate }}
        } @else {
          {{ car.gearbox.steps }} {{ 'carDetail.specification.gearboxSpeed' | translate }}
        }
      </app-inline-params-item>
    }
    @if (car.body?.seats) {
      <app-inline-params-item [label]="'carDetail.specification.seats' | translate">
        {{ car.body?.seats }}
      </app-inline-params-item>
    }
    @if (car.body?.externalColor?.title && car.body?.externalColor?.isMetal) {
      <app-inline-params-item [label]="'carDetail.specification.color' | translate"> {{ car.body?.externalColor?.title | firstCapital }} {{ car.body?.externalColor?.isMetal ? ' - ' + ('carDetail.specification.colorMetalic' | translate) : '' }} </app-inline-params-item>
    }
  }
</app-inline-params>
